import type { FunctionComponent } from 'react';

type HardSkillIconProperties = {
    readonly variant: 'feedback' | 'job-architecture' | 'job-profile';
};
export const HardSkillIcon: FunctionComponent<HardSkillIconProperties> = ({ variant }) => {
    return (
        // biome-ignore lint/a11y/noSvgWithoutTitle: suppressed due to migration
        <svg fill="none" height="16" style={{ flexShrink: 0 }} viewBox="0 0 16 16" width="16">
            <path
                d="M15.6858 14.4502C15.8258 14.6952 15.6489 15 15.3668 15H0.633249C0.351083 15 0.174186 14.6952 0.31418 14.4502L7.68093 1.55837C7.82201 1.31149 8.17799 1.31149 8.31907 1.55837L15.6858 14.4502Z"
                fill={variant === 'job-profile' || variant === 'feedback' ? '#040F16' : '#FF6C00'}
            />
        </svg>
    );
};
